import { createContext } from "react";
import netlifyIdentity from 'netlify-identity-widget';

const UserContext = createContext(netlifyIdentity.currentUser());
export default UserContext;
